/* eslint-disable */
import { client } from './client';
import { appConfig } from '../config/app-config';
import { CancelToken } from 'axios';
import { ProductPermissions } from '../constants/constants';
import { User } from '../types/types';

export const getCurrentUser = (): Promise<User> =>
  client('users/current', { method: 'GET' }, appConfig.apiUrls.container);

export const getUserPreferences = (productType: string) =>
  client(
    `users/current/preferences/${productType}`,
    { method: 'GET' },
    appConfig.apiUrls.container
  );

export const getUserPermissions = (
  productType: string
): Promise<ProductPermissions[]> =>
  client(
    `users/current/permissions/${productType}`,
    { method: 'GET' },
    appConfig.apiUrls.container
  );

export const setUserPreferences = (
  productType: string,
  payload: Record<string, any>,
  cancelToken?: CancelToken
) =>
  client(
    `users/current/preferences/${productType}`,
    {
      method: 'PATCH',
      body: [payload],
      cancelToken,
    },
    appConfig.apiUrls.container
  );

export const getUserStores = () =>
  client(
    'users/current/stores?q=permissions[:includes]=RACPAD_DAP',
    { method: 'GET' },
    appConfig.apiUrls.container
  );

export const GetDropOptions = async (
  payload: any,
  store?: any,
  value?: any
) => {
  if (store) {
    return await client(
      `drop/options?store=${value}`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.orderForm,
      true
    );
  } else {
    return await client(
      `drop/options?authkey=${value}`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.orderForm,
      true
    );
  }
};

export const sendOneTimePasscode = async (
  payload: any,
  store: any,
  value: any
) => {
  try {
    if (store) {
     
      return await client(
        `otp/send?store=${value}`,
        { method: 'POST', payload: payload },
        appConfig.apiUrls.orderForm
      );
    } else {
   
      return await client(
        `otp/send?authkey=${value}`,
        { method: 'POST', payload: payload },
        appConfig.apiUrls.orderForm
      );
    }
  } catch (e: any) {
    return e;
  }
};

export const validateOneTimePassword = async (
  payload: any,
  store: any,
  value: any
) => {
  try {
    if (store) {
      return await client(
        `otp/send?store=${value}`,
        { method: 'POST', payload: payload },
        appConfig.apiUrls.orderForm
      );
    } else {
      return await client(
        `otp/send?authkey=${value}`,
        { method: 'POST', payload: payload },
        appConfig.apiUrls.orderForm
      );
    }
  } catch (e: any) {
    return e;
  }
};

export const uploadVerificationDocuments = async (
  payload: any,
  store: any,
  value: any
) => {
  try {
    if (store) {
      return await client(
        `verification/document/upload?store=${value}`,
        { method: 'POST', payload: payload },
        appConfig.apiUrls.orderForm
      );
    } else {
      return await client(
        `verification/document/upload?authkey=${value}`,
        { method: 'POST', payload: payload },
        appConfig.apiUrls.orderForm
      );
    }
  } catch (e: any) {
    return e;
  }
};

export const getVerificationDocuments = async (
  payload: any,
  store: any,
  value: any
) => {
  try {
    if (store) {
      return await client(
        `verification/document/?store=${value}`,
        { method: 'POST', payload: payload },
        appConfig.apiUrls.orderForm
      );
    } else {
      return await client(
        `verification/document/?authkey=${value}`,
        { method: 'POST', payload: payload },
        appConfig.apiUrls.orderForm
      );
    }
  } catch (e: any) {
    return e;
  }
};

export const CreateCustomerStg = async (payload: any, store?: any, value?: any) => {
  try {

    if (store) {
      return await client(
        `manage/?store=${value}`,
        { method: 'POST', payload: payload },
        appConfig.apiUrls.micro
      );
    } else {
      return await client(
        `manage/?authkey=${value}`,
        { method: 'POST', payload: payload },
        appConfig.apiUrls.micro
      );
    }
  } catch (e: any) {
    return e;
  }
};
export const getCustomerStgDetails = async (identifer: any, store: any, value: any) => {
  try {
    if (store) {
      return await client(
        `fetch/${identifer}/?store=${value}`,
        { method: 'GET', body: {} },
        appConfig.apiUrls.micro
      );
    } else {
      return await client(
        `fetch/${identifer}/?authkey=${value}`,
        { method: 'GET', body: {} },
        appConfig.apiUrls.micro
      );
    }
  }
  catch (err: any) {
    console.log(err);
    return err;
  }
}

export const validateAuthKey = async (payload: any, store: boolean) => {
  try {
    const body: any = {};
    if (store) {
      body.storeNumber = payload;
      return await client(
        `accesslink/validate?store=${payload}`,
        { method: 'POST', payload: body },
        appConfig.apiUrls.orderForm
      );
    } else {
      body.authKey = payload;
      return await client(
        `accesslink/validate?authkey=${payload}`,
        { method: 'POST', payload: body },
        appConfig.apiUrls.orderForm
      );
    }


  } catch (e: any) {
    return e;
  }
};

export const GetCustomerDetails = async (payload: any, store?: any, value?: any) => {
  if (store) {
    return await client(
      `customer/find?store=${value}`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.orderForm,
      true
    );
  }
  else {
    return await client(
      `customer/find?authkey=${value}`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.orderForm,
      true
    );
  }
};

export async function UpdateCustomer(payload: any, store?: any, value?: any) {
  if (store) {
    return await client(
      `customer/update?store=${value}`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.orderForm,
      true
    );
  }
  else {
    return await client(
      `customer/update?authkey=${value}`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.orderForm,
      true
    );
  }

}


export const getConfigDetails = async (payload: any, store?: any, value?: any) => {
  try {
    if (store) {
      return await client(
        `get/config?store=${value}`,
        { method: 'POST', payload: payload },
        appConfig.apiUrls.orderForm
      );
    }
    else {
      return await client(
        `get/config?authkey=${value}`,
        { method: 'POST', payload: payload },
        appConfig.apiUrls.orderForm
      );
    }
  } catch (e: any) {
    console.error('Error fetching config details:', e);
    return e;
  }
};

export const getNAATAccessLink = async (store?: any, value?: any) => {
  try {
    if (store) {
      return await client(
        `accesslink?store=${value}`,
        { method: 'GET', body: {} },
        appConfig.apiUrls.micro
      );
    }
    else {
      return await client(
        `accesslink?authkey=${value}`,
        { method: 'GET', body: {} },
        appConfig.apiUrls.micro
      );
    }
  } catch (e: any) {
    console.error('Error fetching config details:', e);
    return e;
  }
};